module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The King’s Chameleon")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "title_page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/title_page"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#disclaimer"
    }
  }, [_vm._v("Disclaimer")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#tumbledown-dick"
    }
  }, [_vm._v("Tumbledown Dick")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#may-1659"
    }
  }, [_vm._v("May 1659")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#part-one"
    }
  }, [_vm._v("Part One")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#restoration"
    }
  }, [_vm._v("Restoration")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#section"
    }
  }, [_vm._v("1660–1662")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#honest-george"
    }
  }, [_vm._v("Honest George")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#februarymay-1660"
    }
  }, [_vm._v("February–May 1660")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#indemnity-and-oblivion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indemnity and Oblivion")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#june-1660may-1661",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1660–May 1661")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#katherine-villiers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Katherine Villiers")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#may-1661",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May 1661")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-chase",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chase")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#junejuly-1661",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June–July 1661")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-launching",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#august-1661february-1662",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August 1661–February 1662")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#part-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#contagion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contagion")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#section-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1662–1666")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#on-his-majestys-secret-service",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On His Majesty’s Secret Service")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#march-1662",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1662")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-birds-caged",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birds Caged")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#march-1662-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1662")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#rendition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rendition")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#march-1662-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1662")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-home-coming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Home-Coming")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#march-1662-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March 1662")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-deodand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deodand")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#april-1662september-1664",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April 1662–September 1664")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-plague",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Plague")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#october-1664april-1666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October 1664–April 1666")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#part-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#conflagration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conflagration")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#section-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1666–1667")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#battle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Battle")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#mayjuly-1666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May–July 1666")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#holmess-bonfire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holmes’s Bonfire")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#julyoctober-1666",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July–October 1666")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-triangle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Triangle")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#october-1666may-1667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October 1666–May 1667")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#disaster-and-disgrace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disaster and Disgrace")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#june-1667",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1667")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#part-four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#redemption",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redemption")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#section-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1667–1672")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#rupert",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rupert")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#june-1667january-1670",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1667–January 1670")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-kings-chameleon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The King’s Chameleon")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#january-1670august-1672",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January 1670–August 1672")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#destiny",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destiny")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#august-1672august-1673",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August 1672–August 1673")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#kit-faulkner-naval-adventures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kit Faulkner Naval Adventures")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden",
      "id": "landmarks"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/nav#toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/title_page"
    }
  }, [_vm._v("Start of Content")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 57
// module chunks = 0